import styles from './styles.scss';
import { Button } from 'components/Button';

interface MergedProps {
  header: string;
  body: string;
  button: string;
  action?: () => void;
  href?: string;
}

export const HelpArea = ({ header, body, button, action, href }: MergedProps) => {
  return (
    <div className={styles.area}>
      <div className={styles.description}>
        <h3>{header}</h3>
        <p>{body}</p>
      </div>
      <Button
        appearance="tertiary"
        border="thin"
        invert
        onClick={action}
        href={href}
        className={styles.button}
      >
        {button}
      </Button>
    </div>
  );
};
